exports = module.exports = require("../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".remove{width:38px;height:38px;box-shadow:0 4px 4px rgba(0,0,0,.2);color:#fff;border-radius:50%;display:grid;align-items:center;justify-items:center;padding-bottom:3px;cursor:pointer;transition:all .4s;grid-column:close;background-color:#73126c}.remove:hover{filter:brightness(.9)}.remove:hover svg{transform:rotate(-90deg) scale(1.25)}.remove svg{transition:all .4s}body[dir=rtl] .remove:hover svg {\n  transform: rotate(90deg) scale(1.25);\n}\n", ""]);

// exports
